import { Component, Input } from '@angular/core';
import { Platform } from '@ionic/angular';
import { GlobalDataService } from 'src/app/services/global-data.service';
import { CinemaProvider } from 'src/app/types/movie';

@Component({
  selector: 'app-movie-card',
  templateUrl: './movie-card.component.html',
  styleUrls: ['./movie-card.component.scss'],
})
export class MovieCardComponent {
  cinemaProvider: CinemaProvider;
  desktopDevice: boolean = false;

  @Input() movie;

  constructor(
    private globalData: GlobalDataService,
    private platform: Platform
  ) {
    this.globalData.dataChange.subscribe((value) => {
      this.setCinemaProvider(value.cinemaProvider);
    });

    this.platform.ready().then(() => {
      this.desktopDevice =
        this.platform.is('desktop') ||
        (typeof window !== 'undefined' && window.innerWidth > 1200);
    });
  }

  /**
   * Save mall specific cinema provider
   */
  setCinemaProvider(provider) {
    this.cinemaProvider = provider;
  }

  ngOnInit() {
    const initialMallData = this.globalData.getGlobalData();
    if (initialMallData) this.setCinemaProvider(initialMallData.cinemaProvider);
  }
}
